<template>
  <div class="work-wrap">
    <div class="work-top-box">
      <div @click="backHandle">返回</div>
      <div class="cell" style="width: calc(100% - 130px); text-align: center"></div>
      <div></div>
    </div>

    <div class="work-center-box">
      <div class="mt-10" style="overflow-y: auto; height: calc(100% - 70px)">
        <div class="work-card-box">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">故障上报</div>
          </div>
          <div class="work-content-box mt-10">
            <!-- <div class="">项目名称：{{ detailData.organName }}</div>
            <div class="mt-10">故障类型：{{ detailData.faultTypeName }}</div> -->
            <div class="mt-10">安装位置：{{ detailData.space }}</div>
            <div class="mt-10">
              设备名称：
              <span v-if="detailData.deviceList.length">
                <span v-for="(item, i) in detailData.deviceList" :key="i">
                  <span style="word-break: break-all; white-space: pre-wrap">{{ item.deviceName }}（{{ item.deviceNo }}）</span>
                  <span v-if="i < detailData.deviceList.length - 1">，</span>
                </span>
              </span>
              <span v-else>—</span>
            </div>

            <!-- <div class="mt-10">设备厂家：{{ detailData.iotProductName }}</div>
            <div class="mt-10">设备类型：{{ detailData.productTypeName }}</div> -->
            <div class="mt-10">上报时间：{{ detailData.reportTime }}</div>
            <div class="mt-10">
              故障图片：
              <div style="display: flex; flex-wrap: wrap; align-items: center" class="mt-5">
                <div v-for="(obj, j) in faultImages" :key="j" class="mr-10 mt-5">
                  <el-image style="width: 100px; max-height: 100px" :src="obj" :preview-src-list="faultImages"></el-image>
                </div>
              </div>
            </div>
            <div class="mt-10" style="word-break: break-all">故障备注：{{ detailData.faultDescription }}</div>
          </div>
        </div>

        <div class="work-card-box mt-10">
          <div class="work-title">
            <div class="title cell" style="font-weight: bold">审核</div>
          </div>
          <div class="work-content-box mt-10">
            <div class="">审核时间：{{ detailData.applyTime ? detailData.applyTime : '—' }}</div>
            <div class="mt-10">审核结果：{{ detailData.applyStatus == 1 || detailData.applyStatus == 2 ? detailData.applyStatusName : '—' }}</div>
            <div class="mt-10" style="word-break: break-all">审核备注：{{ detailData.remark ? detailData.remark : '—' }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faultImages: [],
      detailData: {
        deviceList: [],
      },
    };
  },
  activated() {
    this.getDetailData();
  },
  methods: {
    getDetailData() {
      let params = {
        id: this.$route.query.id,
      };
      this.$http.get(this.$API.repair_apply_detail, { params }).then((res) => {
        this.faultImages = [];
        this.detailData = res.data || {};
        if (!this.detailData.filesponseList) {
          this.detailData.filesponseList = [];
        }
        this.detailData.filesponseList.forEach((item) => {
          this.faultImages.push(item.fileUrl);
        });
      });
    },
    backHandle() {
      // this.$router.push({ path: '/fault/report/history' });
      let url = '/fault/report/history';
      window.location.assign(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.work-wrap {
  height: 100%;
}
.work-top-box {
  display: flex;
  height: 50px;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  padding: 0 10px;
}
.work-center-box {
  padding: 0 10px;
  height: 100%;
}
.work-card-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  .work-title {
    display: flex;
    .work-status {
      flex: 1 0 100px;
      text-align: right;
      font-size: 1.6rem;
    }
    .title {
      font-size: 1.6rem;
    }
  }
  .work-content-box {
    padding: 10px;
    font-size: 1.6rem;
    border-radius: 6px;
    background-color: #f9fafd;
  }
}
.detail-deal-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 40px;
  color: #fff;
  background-color: #2f70ff;
  text-align: center;
}
</style>
